import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { Recommendation, StoreItem } from "../../types/types";

let initialState:StoreItem<Recommendation[]>={
    requestStatus:"not_initiated",
    responseStatus:"not_recieved",
    haveAnIssue:false,
    issue:"",
    data:[]
}

export const recommendedCoursesSlice=createSlice({
    name:'recommendedcourses',
    initialState:initialState,
    reducers:{
        initRecommended:(state,action:PayloadAction<StoreItem<Recommendation[]>>)=>({...action.payload}),
        addRecommended:(state,action:PayloadAction<Recommendation>)=>{state.data.push(action.payload)},
        setRecommended:(state,action:PayloadAction<Recommendation[]>)=>{state.data=action.payload},

        updateRecommended:(state,action:PayloadAction<Recommendation>)=>{
            let index=state.data.findIndex((item)=>item._id===action.payload._id);
            state.data[index]=action.payload;
        },
        removeRecommended:(state,action:PayloadAction<string>)=>{state.data=state.data.filter((item)=>item._id!==action.payload)},
        resetRecommend:(state,action:PayloadAction)=>({...initialState})

    }
})

export const {initRecommended,addRecommended,removeRecommended,updateRecommended,resetRecommend,setRecommended}=recommendedCoursesSlice.actions;
export default recommendedCoursesSlice.reducer;